import createIcon from '../../createIcon';

/**
 * @component @name SyncProblem
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMyAxMkMzIDE0LjIxIDMuOTEgMTYuMiA1LjM2IDE3LjY0TDMgMjBIOVYxNEw2Ljc2IDE2LjI0QzUuNjggMTUuMTUgNSAxMy42NiA1IDEyQzUgOS4zOSA2LjY3IDcuMTcgOSA2LjM1VjQuMjZDNS41NSA1LjE1IDMgOC4yNyAzIDEyWk0xMSAxN0gxM1YxNUgxMVYxN1pNMjEgNEgxNVYxMEwxNy4yNCA3Ljc2QzE4LjMyIDguODUgMTkgMTAuMzQgMTkgMTJDMTkgMTQuNjEgMTcuMzMgMTYuODMgMTUgMTcuNjVWMTkuNzRDMTguNDUgMTguODUgMjEgMTUuNzMgMjEgMTJDMjEgOS43OSAyMC4wOSA3LjggMTguNjQgNi4zNkwyMSA0Wk0xMSAxM0gxM1Y3SDExVjEzWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const SyncProblem = createIcon('SyncProblem', [
  [
    'path',
    {
      d: 'M3 12C3 14.21 3.91 16.2 5.36 17.64L3 20H9V14L6.76 16.24C5.68 15.15 5 13.66 5 12C5 9.39 6.67 7.17 9 6.35V4.26C5.55 5.15 3 8.27 3 12ZM11 17H13V15H11V17ZM21 4H15V10L17.24 7.76C18.32 8.85 19 10.34 19 12C19 14.61 17.33 16.83 15 17.65V19.74C18.45 18.85 21 15.73 21 12C21 9.79 20.09 7.8 18.64 6.36L21 4ZM11 13H13V7H11V13Z',
      key: '1qije4',
    },
  ],
]);

export default SyncProblem;
